import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseProductColor } from "./UseProductColor";

export default function ColorAutoComplete(props) {
  const { getAllColorList } = UseProductColor();
  const [selectedColor, setSelectedColor] = useState();
  const [productColorRes, setProductColorRes] = useState();

  useEffect(() => {
    getAllColorList((colors) => {
      setProductColorRes(colors);
    });
  }, []);

  useEffect(() => {
    if (productColorRes && props.selectedColorID) {
      setSelectedColor(
        productColorRes.colors.find((m) => m.id == props.selectedColorID)
      );
    }
  }, [productColorRes, props.selectedColorID]);
  useEffect(() => {
    if (selectedColor) {
      props.setter({
        ...props.lvl2State,
        colorID: selectedColor.id,
      });
    }
  }, [selectedColor]);

  return productColorRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.cluster && "100%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        value={selectedColor ? selectedColor : ""}
        options={productColorRes.colors ? productColorRes.colors : []}
        getOptionLabel={(colors) => (colors.faName ? colors.faName : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} label="رنگ" />}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedColor(newValue);
          } else {
            setSelectedColor();
            props.setter({
              ...props.lvl2State,
              colorID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllColorList((colors) => {
            setProductColorRes(colors);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/productcolors" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
